import { jsx as n } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import t from "./styles.module.less.js";
const p = i((a, r) => {
  var e, o;
  const { value: l, onChange: s, error: u } = a;
  return /* @__PURE__ */ n(
    "input",
    {
      ref: r,
      ...a.props,
      className: `${t.emailInput} ${((e = a.props) == null ? void 0 : e.className) || ""} ${u ? t.error : ""}`,
      type: "email",
      value: l || "",
      onChange: (m) => s(m.target.value),
      autoFocus: typeof ((o = a.props) == null ? void 0 : o.autoFocus) == "boolean" ? a.props.autoFocus : !1,
      disabled: a.disabled
    }
  );
});
p.displayName = "EmailInput";
export {
  p as EmailInput
};
